import { MdDelete } from "react-icons/md";
import { BiRename } from "react-icons/bi";
import { useTheme } from "../../../context/useThemeContext";
import {
    FaCopy,
    FaFileExport,
    FaFileImport,
    FaFolderClosed,
    FaNoteSticky,
    FaPaste,
} from "react-icons/fa6";
import useMainStore from "../../../stores/mainStore";
import ContextMenuItem from "../ContextMenuItem";
import { ContextMenuItemHover } from "../ContextMenuItemHover";
import { ContextMenuSeparator } from "../ContextMenu";
import ChangeFolderContextMenu from "./subMenus/changeFolderContextMenu";
import ExportTextFileContextMenu from "./subMenus/exportTextFileContextMenu";
import { IoClose } from "react-icons/io5";
import { importNoteFile } from "../../../utility/exportImportData";
import { useGetEditor } from "../../../context/useEditorContext";

export default function NoteContextMenu(props: {
    id: string;
    copy: () => void;
    paste: () => void;
    duplicate: () => void;
    rename: () => void;
    open: () => void;
    changeFolder: () => void;
    close: () => void;
    delete: () => void;
}) {
    const editor = useGetEditor().editor.current;


    const { theme } = useTheme();
    const copyHTML = useMainStore((state) => state.temp?.copyHTML);
    const selectedNoteID = useMainStore((state) => state.data.selectedNoteID);
    const openedNoteIDs = useMainStore((state) => state.data.openedNoteIDs);

    // Render
    return (
        <div>
            <ContextMenuItem
                label="Copy"
                icon={<FaCopy size={14} />}
                callbackFunction={() => {
                    props.copy();
                }}
            />
            <ContextMenuItem
                label="Paste"
                disabled={!copyHTML}
                icon={<FaPaste size={14} />}
                callbackFunction={() => {
                    props.paste();
                }}
            />
            <ContextMenuSeparator />

            <ContextMenuItem
                label="Rename"
                icon={<BiRename size={14} />}
                callbackFunction={() => {
                    props.rename();
                }}
            />
            <ContextMenuItem
                label="Open"
                disabled={selectedNoteID === props.id}
                icon={<FaNoteSticky size={14} />}
                callbackFunction={() => {
                    props.open();
                }}
            />

            <ContextMenuItem
                label="Close"
                disabled={!openedNoteIDs.includes(props.id || "undefined")}
                icon={<IoClose size={14} />}
                callbackFunction={() => {
                    props.close();
                }}
            />

            <ContextMenuSeparator />

            <ContextMenuItem
                label="Duplicate"
                icon={<BiRename size={14} />}
                callbackFunction={() => {
                    props.duplicate();
                }}
            />

            <ContextMenuSeparator />

            <ContextMenuItemHover
                label="Change Folder"
                icon={<FaFolderClosed size={14} />}
                callbackFunction={() => {
                    props.changeFolder();
                }}
                secondaryContextMenu={
                    props.id && <ChangeFolderContextMenu noteID={props.id} />
                }
            />
            <ContextMenuSeparator />

            <ContextMenuItem
                label="Import"
                icon={<FaFileImport size={14} className="ml-[-2px]" />}
                callbackFunction={() => {
                    if(!props.id) return
                    importNoteFile(props.id, editor);
                }}
            />
            <ContextMenuItemHover
                label="Export"
                icon={<FaFileExport size={14} className="ml-[2px] mr-[-2px]" />}
                callbackFunction={() => {
                    props.changeFolder();
                }}
                secondaryContextMenu={
                    props.id && <ExportTextFileContextMenu noteID={props.id} />
                }
            />

            <ContextMenuSeparator />
            <ContextMenuItem
                label="Delete"
                icon={<MdDelete size={16} />}
                callbackFunction={() => {
                    props.delete();
                }}
            />
        </div>
    );
}
